<template>
  <v-container 
    v-if="!$apollo.loading"
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      v-if="!editSection && !editLecture"
      justify-center
      wrap
    >
      <v-flex
        xs12
        pr-0
        pl-0
        :class="{'order-3': courseSections.length !== 0}"
      >
        <v-btn
          style="display:inline;margin-top:-6px;"
          small
          outlined
          @click="openCreateSection()"
        >
          <span v-if="courseSections.length === 0">
            {{ $t('modules.sectionAdd') }}
          </span>
          <v-tooltip
            v-if="courseSections.length !== 0"
            right
          >
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">
                mdi-plus-circle-outline
              </v-icon>
            </template>
            {{ $t('modules.sectionAdd') }}
          </v-tooltip>
        </v-btn>
      </v-flex>
      <v-flex
        v-if="courseSections.length !== 0"
        pl-0
        pr-0
        xs12
        order-2
      >
        <v-expansion-panels
          v-model="openedPanelSection"
          accordion
        >
          <v-expansion-panel
            v-for="section in courseSections"
            :key="section.id"
          >
            <v-expansion-panel-header
              :color="$vuetify.theme.dark ? $vuetify.theme.themes.dark.background : $vuetify.theme.themes.light.background"
              @mouseenter="toggelShowButton(section.id)"
              @mouseleave="toggelShowButton('')"
            >
              <v-container
                fill-height
                fluid
                pa-0
                justify-start
                wrap
              >
                <v-flex
                  class="text-left"
                  pa-0
                  xs6
                  style="line-height: 28px;"
                >
                  {{ section.name }}
                </v-flex>
                <v-flex
                  v-show="showButtonSection === section.id"
                  class="text-right"
                  pa-0
                  xs6
                >
                  <v-btn
                    :disabled="$apollo.loading"
                    class="mr-2"
                    outlined 
                    small
                    text
                    @click.stop="handleSelectedSection(section)"
                  >
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="section.lectures.length === 0"
                    :disabled="$apollo.loading"
                    outlined 
                    small
                    text
                    class="mr-2"
                    @click.stop="confirmDeleteSection(section)"
                  >
                    <v-icon>mdi-bucket-outline</v-icon>
                  </v-btn>
                </v-flex>
              </v-container>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-layout
                wrap
                pt-8
                pb-8
                style="margin: 0;"             
              >
                <v-flex
                  xs12
                  pa-0
                  mt-2
                  :class="[section.lectures.length !== 0 ? 'order-3' : 'order-1']"
                >
                  <v-btn
                    style="display:inline;"
                    small
                    outlined
                    @click="openCreateLecture(section)"
                  >
                    <span v-if="section.lectures.length === 0">
                      {{ $t('modules.lectureAdd') }}
                    </span>
                    <v-tooltip
                      v-if="section.lectures.length !== 0"
                      right
                    >
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">
                          mdi-plus-circle-outline
                        </v-icon>
                      </template>
                      {{ $t('modules.lectureAdd') }}
                    </v-tooltip>
                  </v-btn>
                </v-flex>
                <v-flex
                  v-if="section.lectures.length !== 0"
                  order-2
                  pa-0
                  ma-0
                >
                  <v-data-table
                    class="text-no-wrap" 
                    :headers="headers"
                    :items="section.lectures"
                    :hide-default-footer="true"
                    :mobile-breakpoint="0"
                    :items-per-page="200"
                    order-3
                  >
                    <template
                      slot="headerCell"
                      slot-scope="{ header }"
                    >
                      <span
                        v-text="header.text"
                      />
                    </template>
                    <template v-slot:item.name="{ item }">
                      {{ item.name }}
                    </template>                
                    <template v-slot:item.actions="{ item }">
                      <div class="text-right">
                        <v-btn
                          :disabled="$apollo.loading"
                          class="mr-2"
                          outlined 
                          small
                          text
                          @click="handleEditLecture(item, section.id)"
                        >
                          <v-icon>mdi-pencil-outline</v-icon>
                        </v-btn>
                        <v-btn
                          :disabled="$apollo.loading"
                          outlined 
                          small
                          text
                          @click="confirmDeleteLecture(item, section.id)"
                        >
                          <v-icon>mdi-bucket-outline</v-icon>
                        </v-btn>
                      </div>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-flex>
      <v-flex
        v-else
        class="not-found"
        xs12
      >
        <v-card>
          <v-icon>mdi-ghost</v-icon>
          <p>{{ $t('modules.sectionNotFound') }}</p>
        </v-card>
      </v-flex>
    </v-layout>
    <new-or-edit-section 
      v-if="editSection"
      :whitelabel-uuid="whitelabelUuid"
      :section="selectedSection"
      :course-uuid="courseUuid"
      @closeEditSection="closeEditSection"
    />
    <new-or-edit-lecture
      v-if="editLecture"
      :whitelabel-uuid="whitelabelUuid"
      :lecture="selectedLecture"
      :course-uuid="courseUuid"
      :section-id="selectedSectionId"
      @closeEditLecture="closeEditLecture"
    />
    <helper-confirm-dialog
      v-if="confirmDialog"
      :show-dialog="confirmDialog"
      :text="$t('modules.sectionReallyDelete', {name: selectedSection ? selectedSection.name : selectedLecture.name})"
      @closeConfirmDialog="closeConfirmDialog"
    />
  </v-container>
</template>
<script>
import COURSE_SECTIONES_QUERY from "@/graphql/queries/modules/LmsCourseSections.gql";
import COURSE_LECTURES_QUERY from "@/graphql/queries/modules/LmsCourseLectures.gql";
import SECTION_DELETE_MUTATION from "@/graphql/mutations/modules/LmsSectionDelete.gql";
import LECTURE_DELETE_MUTATION from "@/graphql/mutations/modules/LmsLectureDelete.gql";
import NewOrEditSection from './partial/NewOrEditSection.vue';
import NewOrEditLecture from './partial/NewOrEditLecture.vue';

export default {
  name: 'LecturesLabel',
  components: {
    NewOrEditSection,
    NewOrEditLecture
  },
  props: {
    whitelabelUuid: {
      type: String,
      default: null
    },
    courseUuid: {
      type: String,
      default: null
    },
    courseId: {
      type: String,
      default: null
    },
    course: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      loading: false,
      confirmDialog: false,
      editSection: false,
      editLecture: false,
      showButtonSection: '',
      openedPanelSection: null,
      selectedSectionId: '',
      selectedSection: null,
      selectedLecture: null,
      headers: [
        {
          sortable: false,
          text: this.$t('modules.lectureName'),
          value: 'name'
        },
        {
          sortable: false,
          text: '',
          value: 'actions',
        },
      ]
    }
  },
  computed: {
    courseSections() {
      let addLectureToSection = [];
      const sortSection = this.moduleLmsCourseSections;
      let allLectures = this.moduleLmsCourseLectures;
      if(sortSection) {
        let sectionSort = sortSection.sort((a,b) => a.sort_order - b.sort_order);
        if(allLectures) {
            addLectureToSection = sectionSort.map((section) => {
              const lectures = allLectures.filter(lecture => lecture.section.id === section.id);
              return {
                ...section,
                lectures: [...lectures]
              }
            });
        } else {
          addLectureToSection = sectionSort;
        }
      }
      return addLectureToSection;
    }
  },
  methods: {
    closeAllPanels () {
      this.openedPanelSection = null
    },
    openPanel (index) {
      this.openedPanelSection = index
    },
    toggelShowButton(id){
        this.showButtonSection = id;   
    },
    openCreateSection() {
      this.editSection = true;
      this.$emit('handledIsOpenForm', true);
    },
    closeEditSection(isClose) {
      this.editSection = false;
      this.selectedSection = null;
      this.toggelShowButton();
      this.$emit('handledIsOpenForm', false);
      if(isClose) this.$apollo.queries.moduleLmsCourseSections.refetch();
    },
    openCreateLecture(section) {
      this.selectedSectionId = section.id;
      this.editLecture = true;
      this.$emit('handledIsOpenForm', true);
    },
    handleEditLecture(item, sectionId) {
      this.selectedLecture = item;
      this.editLecture = true;
      this.selectedSectionId = sectionId;
      this.$emit('handledIsOpenForm', true);
    },
    closeEditLecture(isClose) {
      this.editLecture = isClose;
      this.$emit('handledIsOpenForm', false);
      this.selectedLecture = null;
      this.selectedSectionId = '';
      this.$apollo.queries.moduleLmsCourseLectures.refetch();
    },
    handleSelectedSection(section){
      this.selectedSection = section;
      this.editSection = true;
      this.$emit('handledIsOpenForm', true);
    },
    confirmDeleteSection(section) {
      this.confirmDialog = true
      this.selectedSection = section
    },
    confirmDeleteLecture(item, sectionId) {
      this.selectedLecture = item;
      this.selectedSectionId = sectionId;
      this.confirmDialog = true;      
    },
    closeConfirmDialog(confirmed) {
      this.confirmDialog = false
      if (confirmed && this.selectedSection) {
        this.handleDeletedSection()
      }
      if (confirmed && this.selectedLecture) {
        this.deleteLecture()
      }
    },
    handleDeletedSection(){
      this.loading = true;
      const params = {
        whitelabel_uuid: this.whitelabelUuid,
        course_uuid: this.courseUuid,
        section_id: this.selectedSection.id
      }
      this.$apollo
        .mutate({
          mutation: SECTION_DELETE_MUTATION,
          variables: params
        })
        .then(data => {
          this.$store.commit('app/setNotifier', this.$t('globals.success'));
          this.loading = false;
          this.selectedSection = null;
          this.$apollo.queries.moduleLmsCourseSections.refetch();
        })
        .catch(error => {
          this.errorHandler(error);
          this.loading = false;
          this.selectedSection = null;
        });
    },    
    deleteLecture() {
      this.loading = true;
      const params = {
        whitelabel_uuid: this.whitelabelUuid,
        course_uuid: this.courseUuid,
        section_id: this.selectedSectionId,
        lecture_id: this.selectedLecture.id
      }
      this.$apollo
        .mutate({
          mutation: LECTURE_DELETE_MUTATION,
          variables: params
        })
        .then(data => {
          this.$store.commit('app/setNotifier', this.$t('globals.success'));
          this.loading = false;
          this.selectedLecture = null;
          this.selectedSectionId = '';
          this.$apollo.queries.moduleLmsCourseLectures.refetch();
        })
        .catch(error => {
          this.errorHandler(error);
          this.loading = false;
          this.selectedLecture = null;
          this.selectedSectionId = '';
        });
    },
  },
  apollo: {
    moduleLmsCourseSections: {
      fetchPolicy: "network-only",
      query() {
        return COURSE_SECTIONES_QUERY;
      },
      variables() {
        return {
            whitelabel_uuid: this.whitelabelUuid,
            course_id: this.courseId
          }
      },
      skip() {
        return !this.whitelabelUuid || !this.courseId;
      },
    },
    moduleLmsCourseLectures: {
      fetchPolicy: "network-only",
      query() {
        return COURSE_LECTURES_QUERY;
      },
      variables() {
        return {
            whitelabel_uuid: this.whitelabelUuid,
            course_id: this.courseId
          }
      },
      skip() {
        return !this.whitelabelUuid || !this.courseId;
      },
    },
  },
}
</script>
<style lang="scss" scoped>
  .v-expansion-panel {
    border: 1px solid #d2d2d2;
    border-bottom: none;
    border-top: none;
    &:last-child {
      border-bottom: 1px solid #d2d2d2;
    }
    &:first-child {
      border-top: 1px solid #d2d2d2;
    }
    &::before {
      box-shadow: none;
    }
  }
  .v-tooltip__content {
    -webkit-transition: none !important;
    -moz-transition: none !important;
    -o-transition: none !important;
    transition: none !important;
  }

</style>